module.exports = __webpack_public_path__ + "static/media/initialState.a3d7a98c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videoPlayer/initialState.png
// module id = 80
// module chunks = 0